import React, { Component } from 'react';
import Joyride, { EVENTS } from 'react-joyride';
import SidebarPayconFtueTooltip from './SidebarPayconFtueTooltip';

class SidebarPayconFtue extends Component {
  state = {
    isTourRunning: true,
  };

  steps = [
    {
      target: '.sidebar-nav .payments .dropdown-toggle',
      disableBeacon: true,
      placement: 'right',
      title: 'New Section',
      content: (
        <span>
          Introducing a new <b>Payments</b> section.
        </span>
      ),
    },
    {
      target: '.sidebar-nav .payments li:nth-child(1)',
      disableBeacon: true,
      placement: 'right',
      title: 'Payment Method was Renamed',
      content: (
        <span>
          The page where you can access your mobile payment activations has been
          renamed from <b>Payment Method</b> to <b>Mobile Payments</b>
        </span>
      ),
    },
    {
      target: '.sidebar-nav .payments li:nth-child(2)',
      disableBeacon: true,
      placement: 'right',
      title: 'New Feature',
      content: (
        <span>
          <b>Payment Configuration</b> allows you to customize the way your
          payment methods appear on your POS
        </span>
      ),
      locale: { last: 'Done' },
    },
  ];

  joyRideHelpers = {};

  handleJumpToStep = toIndex => {
    if (this.joyRideHelpers.go) {
      this.joyRideHelpers.go(toIndex);
    }
  };

  handleJoyrideCallback = joyrideData => {
    const { onTourEnd } = this.props;
    const { type: eventType } = joyrideData;

    if (eventType === EVENTS.TOUR_END) {
      onTourEnd();
    }
  };

  render() {
    const { isTourRunning } = this.state;
    return (
      <Joyride
        run={isTourRunning}
        continuous
        steps={this.steps}
        callback={this.handleJoyrideCallback}
        spotlightPadding={0}
        scrollOffset={-500}
        hideBackButton
        disableCloseOnEsc
        disableOverlayClose
        getHelpers={helpers => (this.joyRideHelpers = helpers)}
        tooltipComponent={tooltipProps => (
          <SidebarPayconFtueTooltip
            onJumpToStep={this.handleJumpToStep}
            {...tooltipProps}
          />
        )}
        floaterProps={{
          disableAnimation: true,
          id: 'sidebarPayconFtue',
        }}
        styles={{
          options: {
            zIndex: 2000,
            arrowColor: '#4a4a4a',
          },
        }}
      />
    );
  }
}

SidebarPayconFtue.defaultProps = {
  onTourEnd: () => {},
};

export default SidebarPayconFtue;
